<div class="input-container">
  <input
    [class.orange-border]="orangeBorder && !control?.value"
    [formControl]="control"
    [ngStyle]="inputStyle"
    [type]="type"
    [class.button-padding]="showUpdateButton"
    [class.error]="showError"
    [placeholder]="placeholder || ''"
    [class.disabled]="disabled"
    [min]="min"
    [max]="max"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="valueChange.emit($any($event.target).value)"
    #input
  />

  @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }

  @if (showUpdateButton) {
    <button
      [class.focused-button]="((inputFocused$ | async) || !!updateButtonStatus) && !showError"
      [ngStyle]="buttonStyle"
      [disabled]="!!updateButtonStatus || showError"
      (click)="onUpdate($event)"
    >
      @if (updateButtonStatus === 'loading') {
        <mat-spinner class="custom-color" diameter="20"></mat-spinner>
      } @else if (updateButtonStatus === 'success') {
        <mat-icon svgIcon="check"></mat-icon>
      } @else {
        Update
      }
    </button>
  }
</div>
